import { Controller } from "@hotwired/stimulus"

/**
 * Select-all checkbox controller for V2::TableComponent.
 *
 * Manages the header "select all" checkbox and keeps it in sync
 * with individual row checkboxes (checked / unchecked / indeterminate).
 *
 * Usage (automatically wired by V2::TableComponent when selectable: true):
 *
 *   <table data-controller="table-select">
 *     <thead>
 *       <th><input type="checkbox" data-table-select-target="selectAll"
 *                  data-action="change->table-select#toggleAll"></th>
 *     </thead>
 *     <tbody>
 *       <tr>
 *         <td><input type="checkbox" data-table-select-target="checkbox"
 *                    data-action="change->table-select#rowChanged"></td>
 *       </tr>
 *     </tbody>
 *   </table>
 */
export default class extends Controller {
  static targets = ["selectAll", "checkbox"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => {
      if (!cb.disabled) cb.checked = checked
    })
    this.selectAllTarget.indeterminate = false
  }

  rowChanged() {
    const total = this.checkboxTargets.filter((cb) => !cb.disabled).length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length

    this.selectAllTarget.checked = checked === total
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }
}
